/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PapiProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * One stop setup for PAPI
   * @param hireAccountUuid The Hire account UUID that identifies the Fountain Hire account to connect with this import provider configuration. This is the external account identifier from Fountain Hire that will be used for worker data import (PAPI Partner API) and synchronization.
   * @returns any PAPI setup completed successfully
   * @throws ApiError
   */
  public postApiServicesecurityProcessesPapiSetupV1(
    hireAccountUuid: string,
  ): CancelablePromise<{
    data?: {
      /**
       * Indicates if the setup operation was successful
       */
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/papi/setup/v1/{hireAccountUuid}',
      path: {
        'hireAccountUuid': hireAccountUuid,
      },
    });
  }

}
